import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListaPageComponent } from './lista-page/lista-page.component';
import { DettaglioPageComponent } from './dettaglio-page/dettaglio-page.component';
import { ElaborazioneWaterSupplyZoneComponent } from './elaborazione-water-supply-zone/elaborazione-water-supply-zone.component';
import { LayerGeoWaterSupplyZoneComponent } from './layer-geo-water-supply-zone/layer-geo-water-supply-zone.component';
import { DettaglioIntersezioniPageComponent } from './dettaglio-interserzioni-page/dettaglio-interserzioni-page.component';

const waterSupplyZoneRoutes: Routes = [
  {
    path: 'lista',
    component: ListaPageComponent,
    children: [],
  },
  {
    path: 'invio-file',
    component: ElaborazioneWaterSupplyZoneComponent,
    children: [],
  },
  {
    path: 'invio-layer-geografici',
    component: LayerGeoWaterSupplyZoneComponent,
    children: [],
  },
  {
    path: ':id',
    component: DettaglioPageComponent,
    children: [],
  },
  {
    path: ':id/modifica-intersezioni',
    component: DettaglioIntersezioniPageComponent,
    children: [],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(waterSupplyZoneRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class WaterSupplyZoneRoutingModule { }
